import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Geist_Mono, Plus_Jakarta_Sans } from 'next/font/google'
import { ClinicProvider } from '@/hooks/use-clinic'
import { ClinicUiProvider } from '@/hooks/use-clinic-ui'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import AppShell from '@/components/generals/app-shell'

const sans = Plus_Jakarta_Sans({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <ClinicProvider>
                <TooltipProvider>
                    <ClinicUiProvider>
                        <AppShell>
                            <Component {...pageProps} />
                        </AppShell>
                    </ClinicUiProvider>
                </TooltipProvider>

                <Toaster theme='light' position='top-right' closeButton />
            </ClinicProvider>
        </div>
    )
}

export default App
